<template>
  <PositionDialogs
    :value="value"
    center
    title="Archive Position"
    :message="message"
    :error-message="errorMessage"
    icon="org_icon_position"
    actionLabel="Archive"
    buttonType="red"
    @input="emit('input', $event)"
    @onAction="emit('onAction')"
    @onClose="emit('onClose')"
  />
</template>

<script setup>
import { computed } from "vue";
import PositionDialogs from "@components/PositionDialogs/PositionDialogs.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false
  },
  name: {
    type: String,
    default: "<position name>"
  },
  errorMessage: {
    type: String,
    default: ""
  }
});

const emit = defineEmits(["input", "onAction", "onClose"]);

const message = computed(() => {
  return `Position ${props.name} is about to be archived.`;
});
</script>
